import { Header } from "./styles/Header.styled";
import { ServicesSectionStyled } from "./styles/ServicesSectionStyled.styled";
import { Footer } from "./styles/Footer.styled";
import upgrade from "./Assets/upgrade.svg";
import interior from "./Assets/interior.svg";
import spraying from "./Assets/spraying.svg";
import transport from "./Assets/transport.svg";
import spare from "./Assets/spare.svg";
import dealership from "./Assets/dealership.svg";
import logo from "./Assets/logo.svg";
import { useState } from "react";

const Services = () => {
  const [isClick, setIsClick] = useState(false);
  const [isNavVisible, setIsNavVisible] = useState(false); // Track navigation visibility

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
    setIsClick(!isClick); // Toggle submenu
  };

  const [selectedNav, setSelectedNav] = useState("Services");

  function handleSelected(selectedButton) {
    setSelectedNav(selectedButton);
  }
  return (
    <>
      <Header>
        <div id="header_wrap">
          <div className="header_top">
            <div className="container">
              <div className="container_bg">
                <div className="site_branding">
                  <a href="/" rel="home" title="Multitibe">
                    <img src={logo} alt="Multitibe" />
                  </a>
                </div>
                <div className="contact_wrap">
                  <div className="animated_contact_info">
                    <div className="location flex_icon ">
                      <a href="/">
                        <i class="fa-solid fa-location-dot"></i>
                      </a>
                      <p>
                        <label htmlFor="">ADDRESS </label>
                        <br />
                        5, Olusoji Idowu Street, Ilupeju, Lagos
                      </p>
                    </div>
                    <div className="phone flex_icon">
                      <a href="tel: +234 703 957 1467">
                        <i className="fa-solid fa-phone-volume fa-shake"></i>
                      </a>
                      <p>
                        <label htmlFor="">CALL US</label>
                        <br />
                        +234 703 957 1467
                      </p>
                    </div>
                  </div>
                  <div className="social_icons">
                    <a
                      className="fa"
                      href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                      title="Facebook"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-facebook-f custom-icon"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                      title="Instagram"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                      title="Tiktok"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i class="fa-brands fa-tiktok"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header_bottom">
            <div className="container">
              <nav className="main_navigation">
                <ul>
                  <li>
                    <a
                      href="/"
                      className={selectedNav === "Home" ? "active" : ""}
                      onCLick={() => handleSelected("Home")}
                    >
                      Home
                    </a>
                  </li>
                  <li>
                    <a
                      href="/about"
                      className={selectedNav === "About" ? "active" : ""}
                      onCLick={() => handleSelected("About")}
                    >
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="/services"
                      className={selectedNav === "Services" ? "active" : ""}
                      onCLick={() => handleSelected("Services")}
                    >
                      Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="/contact"
                      className={selectedNav === "Contact" ? "active" : ""}
                      onCLick={() => handleSelected("Contact")}
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </nav>
              <div className="mobile_container">
                <div className="open-menu" onClick={toggleNav}>
                  {!isClick ? (
                    <i
                      class="fa-solid fa-bars"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  ) : (
                    <i class="fa-solid fa-x"></i>
                  )}
                </div>
                {isNavVisible && (
                  <nav className="mobile_navigation">
                    <ul>
                      <li>
                        <a
                          href="/"
                          className={
                            selectedNav === "Home" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("Home")}
                        >
                          Home
                        </a>
                      </li>
                      <li>
                        <a
                          href="/about"
                          className={
                            selectedNav === "About" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("About")}
                        >
                          About
                        </a>
                      </li>
                      <li>
                        <a
                          href="/services"
                          className={
                            selectedNav === "Services" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("Services")}
                        >
                          Services
                        </a>
                      </li>
                      <li>
                        <a
                          href="/contact"
                          className={
                            selectedNav === "Contact" ? "mobile_active" : ""
                          }
                          onCLick={() => handleSelected("Contact")}
                        >
                          Contact
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
                {/* <div className="open-menu">
                        <i
                          class="fa-solid fa-bars"
                          style={{ marginLeft: "10px" }}
                        ></i>
                      </div>
                      <nav className="mobile_navigation">
                        <ul>
                          <li>
                            <a
                              href="/"
                              className={
                                selectedNav === "Home" ? "mobile_active" : ""
                              }
                              onCLick={() => handleSelected("Home")}
                            >
                              Home
                            </a>
                          </li>
                          <li>
                            <a
                              href="/about"
                              className={
                                selectedNav === "About" ? "mobile_active" : ""
                              }
                              onCLick={() => handleSelected("About")}
                            >
                              About
                            </a>
                          </li>
                          <li>
                            <a
                              href="/services"
                              className={
                                selectedNav === "Services" ? "mobile_active" : ""
                              }
                              onCLick={() => handleSelected("Services")}
                            >
                              Services
                            </a>
                          </li>
                          <li>
                            <a
                              href="/contact"
                              className={
                                selectedNav === "Contact" ? "mobile_active" : ""
                              }
                              onCLick={() => handleSelected("Contact")}
                            >
                              Contact
                            </a>
                          </li>
                        </ul>
                      </nav> */}
              </div>
            </div>
          </div>
        </div>
      </Header>
      <main className="site-main">
        <ServicesSectionStyled >
            <div className="container">
              <div style={{ textAlign: "center", paddingTop: "50px" }}>
                <h4 className="h4">WE OFFER SERVICES</h4>
                <h2>Our car services</h2>
              </div>
              <div className="services">
                <div className="service" style={{ marginBottom: "50px" }}>
                  <img src={dealership} alt="upgrade" />

                  <div className="content">
                    <div className="content_header">
                      <h4>Automobile Dealership</h4>
                      <p>
                        At Multibe Autos LTD, we offer both brand-new and
                        carefully selected pre-owned vehicles that meet
                        international standards. Our dealership guarantees
                        authenticity, affordability, and performance, helping
                        you find the perfect car for personal use or business
                        needs. With us, you can count on fair pricing and a
                        smooth buying process every time
                      </p>
                    </div>
                  </div>
                </div>
                <div className="service">
                  <img src={spraying} alt="upgrade" />

                  <div className="content">
                    <div className="content_header">
                      <h4>Auto Spray Services</h4>
                      <p>
                        Our auto spray division delivers professional
                        spray-painting and bodywork services that transform
                        vehicles to showroom-standard condition. Whether you
                        require a brand-new look, custom colors, or full
                        restoration, we apply premium paints and advanced
                        finishing techniques for long-lasting, reliable,
                        beautiful, and perfect results
                      </p>
                    </div>
                  </div>
                </div>
                <div className="service">
                  <img src={upgrade} alt="upgrade" />
                  <div className="content">
                    <div className="content_header">
                      <h4>Automobile Upgrading</h4>
                      <p>
                        Give your car a new life with our professional
                        automobile upgrade services. From engine performance
                        tuning to adding modern features like navigation
                        systems, sound upgrades, and luxury accessories, we
                        tailor every service to meet your needs. Our goal is to
                        enhance both the functionality and overall appearance of
                        your vehicle.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="service">
                  <img src={interior} alt="upgrade" />

                  <div className="content">
                    <div className="content_header">
                      <h4>Auto Interior Services</h4>
                      <p>
                        We specialize in designing and upgrading automobile
                        interiors to achieve a luxury finish. From high-quality
                        leather seats to modern dashboards and infotainment
                        systems, our work blends comfort with style. Each
                        project is tailored to your taste, ensuring your car’s
                        interior reflects elegance, durability, and modern
                        design all crafted to perfection
                      </p>
                    </div>
                  </div>
                </div>
                <div className="service">
                  <img src={transport} alt="upgrade" />
                  <div className="content">
                    <div className="content_header">
                      <h4>Import & Export Trade</h4>
                      <p>
                        We specialize in sourcing and delivering high quality
                        vehicles from trusted markets worldwide. Our import and
                        export trade services are designed to give you access to
                        reliable automobiles with complete transparency. Every
                        transaction is handled securely, ensuring that you enjoy
                        excellent value and confidence in your purchase
                      </p>
                    </div>
                  </div>
                </div>
                <div className="service">
                  <img src={spare} alt="upgrade" />

                  <div className="content">
                    <div className="content_header">
                      <h4>Spare Parts</h4>
                      <p>
                        We provide genuine spare parts, premium accessories, and
                        essential auto components tailored to meet your
                        vehicle’s needs. From engines and batteries to tires and
                        rims, our products guarantee durability, reliability,
                        and perfect compatibility, ensuring long-lasting
                        performance, improved safety, and maximum satisfaction
                        for every customer.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </ServicesSectionStyled>
      </main>
      <Footer style={{ marginTop: "100px" }}>
        <div className="container">
          <div className="footer_section">
            <div className="section_1 section_width">
              <h3>Multibe Autos</h3>
              <p>
                Multibe Autos is your trusted partner for all your automotive
                needs.
              </p>
              <div className="social_icons">
                <a
                  className="fa"
                  href="https://www.facebook.com/share/1L9c5YmUit/?mibextid=wwXIfr"
                  title="Facebook"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-facebook-f custom-icon"></i>
                </a>
                <a
                  href="https://www.instagram.com/radeintegratedservicesltd?igsh=eGsxczI2ZmJtdGRy&utm_source=qr"
                  title="Instagram"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@radeintegratedservices?_t=ZN-8w3lzrVdp1q&_r=1"
                  title="Tiktok"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fa-brands fa-x-twitter"></i>
                </a>
              </div>
            </div>
            <div className="section_2 section_width">
              <h3>Services</h3>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Auto Interior Services
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Auto Spray Services
                </a>
              </li>
              <li>
                <a href="/services">
                  {" "}
                  <i class="fa-solid fa-check"></i>Automobile Upgrading
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Automobile Dealership
                </a>
              </li>
              <li>
                <a href="/services">
                  <i class="fa-solid fa-check"></i>Import & Export Trade
                </a>
              </li>
              <li>
                <a href="/services">
                  {" "}
                  <i class="fa-solid fa-check"></i>Spare Parts
                </a>
              </li>
            </div>
            <div className="section_3 section_width">
              <h3>Contact information</h3>
              <li>
                <i class="fa-solid fa-location-dot"></i>
                <span style={{ opacity: 0.7 }}>
                  5, Olusoji Idowu Street, Ilupeju, Lagos
                </span>
              </li>
              <li>
                <i class="fa-solid fa-phone"></i>
                <span>
                  +234 703 957 1467 <br /> +234 810 3690 175{" "}
                </span>
              </li>
              <li>
                <i class="fa-solid fa-envelope"></i>
                <span>info@multibeauto.com</span>
              </li>
            </div>
            <div className="section_4 section_width">
              <h3>Business Hours</h3>
              <dl>
                <dt>Opening Days:</dt>
                <dd>Monday – Friday : 8:00am to 5:00pm</dd>
                <dd>Saturday : 9:00am to 4:00pm</dd>
                <dt>Vacations:</dt>
                <dd>All Sunday Days All Official</dd>
                <dd>Holidays</dd>
              </dl>
            </div>
          </div>
          <p
            style={{
              textAlign: "center",
              padding: "20px 0",
              paddingBottom: "70px",
            }}
          >
            &copy; {new Date().getFullYear()} Multibe Autos. All rights
            reserved.
          </p>
        </div>
      </Footer>
    </>
  );
};

export default Services;
